import { FC } from 'react';

import GenericLayout from '../../../components/generic-layout/GenericLayout';
import Grid2 from '../../../components/grid/Grid2';
import { H2, H3 } from '../../../components/heading/Hx';
import List from '../../../components/list/List';
import ListItem from '../../../components/list/ListItem';
import PageImage from '../../../components/page-image/PageImage';
import { PageImageId } from '../../../components/page-image/type';
import Paragraph from '../../../components/paragraph/Paragraph';
import Route from '../../../components/route/Route';
import Section from '../../../components/section/Section';
import { COLOR } from '../../../theme/type';
import { ARTS } from './arts';
import { MASTERS } from './masters';
import { MILESTONES } from './milestones';

const FalkoZander: FC = () => (
  <GenericLayout title='Falko Zander'>
    <PageImage id={PageImageId.FalkoZander} />

    <Section background={COLOR.Dark3}>
      <H2 center color={COLOR.Gold1} margin={{ bottom: '2rem' }}>
        Gemeinsam auf dem Weg zur besten Version
      </H2>

      <Grid2 spacing='2rem'>
        <Grid2.Item>
          <H3>Kampfkunst Lebenslauf</H3>
          <List bullets itemProps={{ margin: { y: '0.5rem' } }} margin={{ y: '0.75em' }}>
            {MILESTONES.map((text, index) => (
              <ListItem key={index}>{text}</ListItem>
            ))}
          </List>
        </Grid2.Item>
        <Grid2.Item>
          <H3>Wichtige Lehrer</H3>
          <Paragraph>
            Falko Zander war und ist Freund und Schüler mehrerer herausragender (Groß-)Meister:
          </Paragraph>
          <List bullets itemProps={{ margin: { y: '0.5rem' } }} margin={{ y: '0.75em' }}>
            {MASTERS.map((element, index) => (
              <ListItem key={index}>{element}</ListItem>
            ))}
          </List>

          <H3 margin={{ top: '2rem' }}>Mehr zu den Kampfkünsten</H3>
          <List bullets itemProps={{ margin: { y: '0.5rem' } }} margin={{ y: '0.75em' }}>
            {ARTS.map(({ href, text }) => (
              <ListItem key={href}>
                <Route href={href}>{text}</Route>
              </ListItem>
            ))}
          </List>
        </Grid2.Item>
      </Grid2>
    </Section>
  </GenericLayout>
);

export default FalkoZander;
